import { apiClient } from '@/lib/apiClient';

export interface LeadStatsData {
  total: number;
  qualified: number;
  not_interested: number;
  high_score: number;
  leadScoreDistribution: {
    high: number;
    medium: number;
    low: number;
  };
  countries?: Record<string, number>;
  contacts: {
    total_contacts: number;
    missing_email: number;
    missing_phone: number;
    missing_contact: number;
    leads_without_contacts: number;
    leads_with_contacts: number;
    contact_coverage: number;
  };
}

export interface LeadStatsApiResponse {
  total: number;
  qualified: number;
  not_interested: number;
  high_score: number;
  leadScoreDistribution: {
    high: number;
    medium: number;
    low: number;
  };
  countries?: Record<string, number>;
  contacts: {
    total_contacts: number;
    missing_email: number;
    missing_phone: number;
    missing_contact: number;
    leads_without_contacts: number;
    leads_with_contacts: number;
    contact_coverage: number;
  };
}

// In-flight deduplication for simultaneous calls
let inflightStats: Promise<LeadStatsData> | null = null;

class LeadStatsService {
  async getLeadStats(userId?: string): Promise<LeadStatsData> {
    const endpoint = userId && userId !== 'all' 
      ? `/leadsys/stats?user_id_filter=${userId}`
      : `/leadsys/stats`;

    // Deduplicate simultaneous calls to the same endpoint
    if (inflightStats) {
      return inflightStats;
    }

    inflightStats = apiClient.get<LeadStatsApiResponse>(endpoint)
      .finally(() => { inflightStats = null; });

    return inflightStats;
  }
}

export const leadStatsService = new LeadStatsService();
